﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ForecastConfirmationService
 * @description
 * # ForecastConfirmationService
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ForecastConfirmationService', ['ConfirmationService', 'Utils', function (ConfirmationService, Utils) {

      function startNewScenario(message, data) {
          return ConfirmationService.YesNoConfirmation(message, null, data);
      }

      function returnToOriginalStaffWarning(message) {
          return Utils.OpenModal(message, 'ng1/src/common/alertPopup.html', null, { title: 'Cannot assign', action: 'close' });
      }

      function moveToOtherDayPopup(data) {
          return Utils.OpenModal('', 'ng1/src/staffForecasting/confirmations/popups/moveToOtherDayPopup.html', 'MoveToOtherDayController', data);
      }

      function scenarioGenerating() {
          return Utils.OpenModal('', 'ng1/src/staffForecasting/confirmations/popups/newScenarioLoadingPopup.html', null, null, null, null, true);
      }

      function borrowAction(message) {
          return new ConfirmationService.YesNoConfirmation(message, 'ng1/src/staffForecasting/confirmations/popups/borrowAlert.html');
      }

      function undoBorrowAction(message) {
          return new ConfirmationService.YesNoConfirmation(message, 'ng1/src/staffForecasting/confirmations/popups/undoBorrowAlert.html');
      }

      function permissionWarning(message) {
          return new ConfirmationService.YesNoConfirmation(message, 'ng1/src/staffForecasting/confirmations/popups/permissionWarningAlert.html');
      }

      var service = {};

      angular.extend(service, ConfirmationService);
      service.StartNewScenario = startNewScenario;
      service.ReturnToOriginalStaffWarning = returnToOriginalStaffWarning;
      service.MoveToOtherDayPopup = moveToOtherDayPopup;
      service.ScenarioGenerating = scenarioGenerating;
      service.BorrowAction = borrowAction;
      service.UndoBorrowAction = undoBorrowAction;
      service.PermissionWarning = permissionWarning;

      return service;

  }]);